export const dealSlipStatus = {
  PENDINGAGGREGATOR: "PendingAggregator",
};
